import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "calendar-legend" }


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarLegend',
  setup(__props) {

const categories: Record<number, string> = {
  1: '음방',
  2: '자컨',
  3: '방송',
  4: '공연',
  5: '팬미팅',
  6: '곡발매',
  7: '생일',
}

function getCategoryColor(crt: number) {
  switch (crt) {
    case 1: return "#ff6b81";
    case 2: return "#4dabf7";
    case 3: return "#51cf66";
    case 4: return "#f4a261";
    case 5: return "#ff7f50";
    case 6: return "#8e44ad";
    case 7: return "#63e6be";
    default: return "#adb5bd";
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(categories, (name, key) => {
      return _createElementVNode("div", {
        key: key,
        class: "legend-item",
        style: _normalizeStyle({ backgroundColor: getCategoryColor(Number(key)) })
      }, _toDisplayString(name), 5)
    }), 64))
  ]))
}
}

})